export enum FrontendVersionEnum {
    Orca7 = 1,
    OrcaWeb = 2,
}
